<template>
  <div class="app-container">
    <nav-bar></nav-bar>
    <trial-notification-bar></trial-notification-bar>
    <usage-notification-bar></usage-notification-bar>
    <notifications group="alert"></notifications>
    <notifications group="loading" position="top center">
      <template slot="body" slot-scope="props">
        <div class="vue-notification-template vue-notification">
          <div class="notification-title">
            {{ props.item.title }}
            &nbsp;
            <span class="icon">
              <i class="fas fa-spinner fa-pulse"></i>
            </span>
          </div>
          <div class="notification-content" v-html="props.item.text"></div>
        </div>
      </template>
    </notifications>
    <div class="page-content">
      <router-view />
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Foot from '@/components/Footer';
import NavBar from '@/components/ActionsBar';
import TrialNotificationBar from '@/components/TrialNotification';
import UsageNotificationBar from '@/components/UsageNotification';

export default {
  name: 'app',
  components: {
    NavBar,
    TrialNotificationBar,
    UsageNotificationBar,
    Foot
  },
  computed: {
    userData() {
      return this.$store.getters['auth/getUser'];
    }
  },
  watch: {
    userData(user) {
      this.loadCustomerly(user);
    }
  },
  created() {
    this.loadCustomerly(this.userData);
  },
  methods: {
    async loadCustomerly(user) {
      //something changed do something
      let account = (user && user.account) || null;
      let plan =
        (account && account.subscription && account.subscription.plan) || null;
      // Get docuemnts report;
      const { data: report } =
        account && plan
          ? await this.$axios.post(this.$API.documentsReport(), { documents: 'all' })
          : { data: null };
      // send customerly info.
      this.$customerly.load({
        user_id: user._id,
        name: user.name,
        email: user.email,
        attributes: {
          created_at: (account && account.creatAt) || '',
          plan: (plan && plan.name) || '',
          firstUpload: report?.firstDocument?.createdAt,
          documents: report?.totalDocuments,
          visits: report?.totalVisits,
          leads: report?.totalLeads
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/design/index.scss';
</style>
